import api from "./api"; // Assuming you have an api.js that exports an axios instance

const notificationService = {
  getUnreadCount: async () => {
    try {
      const response = await api.get("/notifications/unread_count/");
      // Assuming backend now returns { requester_notifications_count: N, approver_notifications_count: M }
      return {
        requester_notifications_count:
          response.data.requester_notifications_count,
        approver_notifications_count:
          response.data.approver_notifications_count,
      };
    } catch (error) {
      console.error("Error fetching unread notification count:", error);
      // Return default counts on error to prevent TypeError in App.vue
      return {
        requester_notifications_count: 0,
        approver_notifications_count: 0,
      };
    }
  },

  markNotificationsAsRead: async (
    notificationIds = null,
    leaveRequestIds = null,
    notificationType = null
  ) => {
    try {
      const payload = {};
      if (notificationIds) {
        payload.notification_ids = notificationIds;
      }
      if (leaveRequestIds) {
        if (Array.isArray(leaveRequestIds)) {
          for (const id of leaveRequestIds) {
            await api.post("/notifications/mark_as_read/", {
              leave_request_id: id,
            });
          }
        } else {
          payload.leave_request_id = leaveRequestIds;
          await api.post("/notifications/mark_as_read/", payload);
        }
      } else if (notificationType) {
        payload.notification_type = notificationType;
        await api.post("/notifications/mark_as_read/", payload);
      } else {
        // Fallback for general mark as read if needed, though specific is better.
        await api.post("/notifications/mark_as_read/", {});
      }

      console.log("Notifications marked as read successfully.");
    } catch (error) {
      console.error("Error marking notifications as read:", error);
    }
  },

  markApproverNotificationsAsRead: async (leaveRequestId) => {
    try {
      await api.post("/notifications/mark_approver_viewed/", {
        leave_request_id: leaveRequestId,
      });
      console.log(
        `Approver notifications for leave request ${leaveRequestId} marked as read.`
      );
    } catch (error) {
      console.error("Error marking approver notifications as read:", error);
    }
  },
};

export default notificationService;
